import './App.css';
import Main from './components/day9-weather1-main';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Main/>
      </header>
    </div>
  );
}

export default App;
